import { Container } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ContentPageContainer = styled(Container)`
  margin-top: 64px;
`;
